import React from 'react';
import { useAppSelector } from 'src/services/redux/app/store';
import { ExploreMain, ActivityDrawer, Main, InviteUsers, UpgradePlan } from '../partials';
import { MasterInit } from './MasterInit';
import { Content } from './components/Content';
import { Footer } from './components/Footer';
import { ScrollTop } from './components/ScrollTop';
import { AsideDefault } from './components/aside/AsideDefault';
import { HeaderWrapper } from './components/header/HeaderWrapper';
import { Toolbar } from './components/toolbar/Toolbar';
import { PageDataProvider } from './core';

const MasterLayout: React.FC = ({ children }) => {
  const { user } = useAppSelector((state) => state.auth);

  if (user?.company?.is_maintance) return null;

  return (
    <PageDataProvider>
      <div className="page d-flex flex-row flex-column-fluid">
        <AsideDefault />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <HeaderWrapper />

          <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
            <Toolbar />
            <div className="post d-flex flex-column-fluid" id="kt_post">
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      {/* <ExploreMain /> */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}

      <MasterInit />
      <ScrollTop />
    </PageDataProvider>
  );
};

export { MasterLayout };
